module.exports = __webpack_public_path__ + "static/img/nullPage.fe60608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nullPage.png
// module id = 9db61fe5add91a92
// module chunks = 59